module.exports = __webpack_public_path__ + "img/gpic10.png";